import React from 'react';
import { motion } from 'framer-motion';
import { TrendUp, TrendDown } from '@phosphor-icons/react';
import { formatCurrency, formatPercent } from '../lib/utils';
import { useCurrency } from '../context/CurrencyContext';

const PortfolioHolding = ({ holding }) => {
  const isProfit = holding.profit_loss >= 0;
  const { format: fmtCcy } = useCurrency();

  return (
    <motion.div
      whileHover={{ x: 4 }}
      className="glass-card p-6"
      data-testid={`portfolio-holding-${holding.symbol}`}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <h3 className="font-unbounded font-bold text-lg text-white">{holding.symbol}</h3>
            {isProfit ? (
              <TrendUp size={20} className="text-success" weight="bold" />
            ) : (
              <TrendDown size={20} className="text-destructive" weight="bold" />
            )}
          </div>
          <p className="text-sm text-zinc-400">{holding.company_name}</p>
        </div>
        
        <div className="text-right">
          <p className="font-mono text-xl font-bold text-white">{fmtCcy(holding.total_value)}</p>
          <p
            className={`font-mono text-sm font-bold ${
              isProfit ? 'text-success' : 'text-destructive'
            }`}
          >
            {isProfit ? '+' : ''}{fmtCcy(holding.profit_loss)}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 pt-4 border-t border-white/10">
        <div>
          <p className="text-xs text-zinc-500 uppercase tracking-wide mb-1">Shares</p>
          <p className="font-mono font-bold text-white">{holding.shares.toFixed(2)}</p>
        </div>
        <div>
          <p className="text-xs text-zinc-500 uppercase tracking-wide mb-1">Avg. Price</p>
          <p className="font-mono font-bold text-white">{fmtCcy(holding.avg_buy_price)}</p>
        </div>
        <div>
          <p className="text-xs text-zinc-500 uppercase tracking-wide mb-1">Current Price</p>
          <p className="font-mono font-bold text-white">{fmtCcy(holding.current_price)}</p>
        </div>
        <div>
          <p className="text-xs text-zinc-500 uppercase tracking-wide mb-1">Return</p>
          <p
            className={`font-mono font-bold ${
              isProfit ? 'text-success' : 'text-destructive'
            }`}
          >
            {formatPercent(holding.profit_loss_percent)}
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default PortfolioHolding;